export default {
  namespaced: true,
  state     : {
    breadcrumbs: [
      {
        id      : 1,
        text    : 'Главная',
        disabled: false,
        link    : '/',
      },
      {
        id      : 2,
        text    : 'Рейтинги и баллы',
        disabled: false,
        link    : 'rating',
      },
      {
        id      : 3,
        text    : 'История начисления баллов',
        disabled: true,
        link    : 'rating/points_history',
      },
    ],
  },
  getters: {
    breadcrumbs: ({breadcrumbs}) => breadcrumbs,
  },
};
